(function () {
  'use strict';

  var INIT_FLAG = 'evSizeGuideInit';
  var OPEN_CLASS = 'ev-size-guide--open';
  var BODY_LOCK_CLASS = 'ev-size-guide-open';
  var MOUNTED_FLAG = 'evMounted';
  var CM_PER_IN = 2.54;
  var SWATCH_WAIT_MS = 8000;

  function isElementVisible(el, root) {
    if (!el || el.disabled) return false;
    if (el.getAttribute('aria-hidden') === 'true' || el.hidden) return false;
    var node = el;
    while (node && node !== root) {
      if (node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
      if (node.getAttribute && node.getAttribute('hidden') !== null && node.getAttribute('hidden') !== 'false') {
        return false;
      }
      node = node.parentElement;
    }
    return true;
  }

  function getFocusableElements(panel) {
    if (!panel) return [];
    var selector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(panel.querySelectorAll(selector), function (el) {
      return isElementVisible(el, panel);
    });
  }

  function trapTabKey(event, panel) {
    if (event.key !== 'Tab' || !panel) return;
    var focusables = getFocusableElements(panel);
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function buildWhatsAppHref(baseUrl, productTitle, productUrl) {
    var base = baseUrl || 'https://wa.me/971542117007';
    var text = 'Hi East Vibe, I need help choosing a size for: ' + (productTitle || 'this product');
    if (productUrl) {
      text += ' - ' + productUrl;
    }
    var sep = base.indexOf('?') === -1 ? '?' : '&';
    return base + sep + 'text=' + encodeURIComponent(text);
  }

  function ensureChartImage(modal, trigger) {
    var img = modal.querySelector('[data-ev-size-guide-image]');
    if (!img || img.getAttribute('src')) return;

    var src = trigger.getAttribute('data-chart-src');
    if (!src) return;

    img.setAttribute('src', src);
    img.removeAttribute('hidden');
  }

  function showPanelContent(modal, mode) {
    var tableWrap = modal.querySelector('[data-ev-size-guide-table-wrap]');
    var imageWrap = modal.querySelector('[data-ev-size-guide-image-wrap]');
    var fallback = modal.querySelector('[data-ev-size-guide-fallback]');
    var htmlWrap = modal.querySelector('[data-ev-size-guide-html-wrap]');

    if (tableWrap) tableWrap.hidden = mode !== 'table';
    if (imageWrap) imageWrap.hidden = mode !== 'image';
    if (fallback) fallback.hidden = mode !== 'fallback';
    if (htmlWrap) htmlWrap.hidden = mode !== 'html';
  }

  /**
   * Format measures without locale digit shaping.
   * Limitation: Arabic/Russian locales still use Western digits (0-9) for stability.
   */
  function formatMeasure(value) {
    if (!isFinite(value)) return '';
    var rounded = Math.round(value * 10) / 10;
    if (Math.abs(rounded - Math.round(rounded)) < 1e-9) {
      return String(Math.round(rounded));
    }
    return String(rounded);
  }

  function convertValue(raw, fromUnit, toUnit) {
    var num = parseFloat(raw, 10);
    if (!isFinite(num)) return '';
    if (fromUnit === toUnit) return formatMeasure(num);
    if (fromUnit === 'cm' && toUnit === 'in') return formatMeasure(num / CM_PER_IN);
    if (fromUnit === 'in' && toUnit === 'cm') return formatMeasure(num * CM_PER_IN);
    return formatMeasure(num);
  }

  function convertToleranceText(raw, toUnit) {
    var text = raw || '';
    var match = text.match(/(\d+(?:[.,]\d+)?)\s*(cm|in)\b/i);
    if (!match) return text;
    var fromUnit = match[2].toLowerCase();
    var amount = convertValue(match[1].replace(',', '.'), fromUnit, toUnit);
    if (!amount) return text;
    return text.replace(match[0], amount + ' ' + toUnit);
  }

  function applyUnit(panel, toUnit) {
    var root = panel.querySelector('[data-ev-size-guide-table]');
    if (!root) return;
    var sourceUnit = (root.getAttribute('data-ev-sg-source-unit') || 'cm').toLowerCase();
    if (toUnit !== 'cm' && toUnit !== 'in') toUnit = sourceUnit;

    var measures = root.querySelectorAll('[data-ev-sg-measure]');
    Array.prototype.forEach.call(measures, function (el) {
      var raw = el.getAttribute('data-ev-sg-raw');
      el.textContent = convertValue(raw, sourceUnit, toUnit);
    });

    var model = root.querySelector('[data-ev-sg-model]');
    if (model) {
      var template = model.getAttribute('data-ev-sg-model-template') || '';
      var size = model.getAttribute('data-ev-sg-model-size') || '';
      var height = convertValue(model.getAttribute('data-ev-sg-model-raw'), sourceUnit, toUnit);
      var unitLabel = toUnit;
      model.textContent = template
        .replace('__HEIGHT__', height)
        .replace('__UNIT__', unitLabel)
        .replace('__SIZE__', size);
    }

    var tolerance = root.querySelector('[data-ev-sg-tolerance]');
    if (tolerance) {
      var toleranceRaw = tolerance.getAttribute('data-ev-sg-tolerance-raw') || tolerance.textContent || '';
      tolerance.textContent = convertToleranceText(toleranceRaw, toUnit);
    }

    var buttons = root.querySelectorAll('[data-ev-sg-unit]');
    Array.prototype.forEach.call(buttons, function (btn) {
      var active = btn.getAttribute('data-ev-sg-unit') === toUnit;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    root.setAttribute('data-ev-sg-active-unit', toUnit);
  }

  function initUnitToggle(panel) {
    var root = panel.querySelector('[data-ev-size-guide-table]');
    if (!root || root.dataset.evUnitInit === 'true') return;
    root.dataset.evUnitInit = 'true';
    var sourceUnit = (root.getAttribute('data-ev-sg-source-unit') || 'cm').toLowerCase();
    applyUnit(panel, sourceUnit);

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-ev-sg-unit]');
      if (!btn || !root.contains(btn)) return;
      applyUnit(panel, btn.getAttribute('data-ev-sg-unit'));
    });
  }

  function activateTab(panel, tabName) {
    var tabsRoot = panel.querySelector('[data-ev-size-guide-tabs]');
    if (!tabsRoot) return;
    var tabs = tabsRoot.querySelectorAll('[data-ev-size-guide-tab]');
    var panels = tabsRoot.querySelectorAll('[data-ev-size-guide-tabpanel]');
    Array.prototype.forEach.call(tabs, function (tab) {
      var selected = tab.getAttribute('data-ev-size-guide-tab') === tabName;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });
    Array.prototype.forEach.call(panels, function (p) {
      var match = p.getAttribute('data-ev-size-guide-tabpanel') === tabName;
      if (match) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', 'hidden');
      }
    });
  }

  function initTabs(panel) {
    var tabsRoot = panel.querySelector('[data-ev-size-guide-tabs]');
    if (!tabsRoot || tabsRoot.dataset.evTabsInit === 'true') return;
    tabsRoot.dataset.evTabsInit = 'true';

    var tabs = Array.prototype.slice.call(tabsRoot.querySelectorAll('[data-ev-size-guide-tab]'));
    if (!tabs.length) return;

    tabsRoot.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-ev-size-guide-tab]');
      if (!tab || !tabsRoot.contains(tab)) return;
      activateTab(panel, tab.getAttribute('data-ev-size-guide-tab'));
    });

    tabsRoot.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-ev-size-guide-tab]');
      if (!tab || !tabsRoot.contains(tab)) return;
      var index = tabs.indexOf(tab);
      if (index < 0) return;
      var next = index;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        var dir = event.key === 'ArrowRight' ? 1 : -1;
        if (document.documentElement.classList.contains('rtl') || document.documentElement.dir === 'rtl') {
          dir *= -1;
        }
        next = (index + dir + tabs.length) % tabs.length;
        tabs[next].focus();
        activateTab(panel, tabs[next].getAttribute('data-ev-size-guide-tab'));
      } else if (event.key === 'Home') {
        event.preventDefault();
        tabs[0].focus();
        activateTab(panel, tabs[0].getAttribute('data-ev-size-guide-tab'));
      } else if (event.key === 'End') {
        event.preventDefault();
        tabs[tabs.length - 1].focus();
        activateTab(panel, tabs[tabs.length - 1].getAttribute('data-ev-size-guide-tab'));
      }
    });

    activateTab(panel, 'chart');
  }

  /**
   * Variant Swatch King hides `.variants-wrapper` (where the Liquid trigger renders).
   * Mount the trigger into the app's visible `.swatch-size-chart` slot beside Size.
   */
  function pickSwatchSizeChartSlot() {
    var slots = document.querySelectorAll('.swatch-size-chart');
    if (!slots.length) return null;

    var sizeSlot = null;
    Array.prototype.forEach.call(slots, function (slot) {
      if (sizeSlot) return;
      var host = slot.closest('.swatch-single, .swatch-label-container, .swatches');
      var text = ((host && host.textContent) || '').toLowerCase();
      if (text.indexOf('size') !== -1 || text.indexOf('مقاس') !== -1 || text.indexOf('размер') !== -1) {
        sizeSlot = slot;
      }
    });

    if (sizeSlot) return sizeSlot;
    return slots[slots.length - 1];
  }

  function mountTriggersIntoSwatchSlots() {
    var triggers = document.querySelectorAll('[data-ev-size-guide-open]');
    if (!triggers.length) return false;

    var slot = pickSwatchSizeChartSlot();
    if (!slot) return false;

    Array.prototype.forEach.call(triggers, function (trigger, index) {
      if (trigger.dataset[MOUNTED_FLAG] === 'true' && slot.contains(trigger)) return;

      // One visible control in the Size slot; hide extras if Liquid rendered duplicates.
      if (index > 0) {
        trigger.setAttribute('hidden', 'hidden');
        trigger.setAttribute('aria-hidden', 'true');
        return;
      }

      slot.appendChild(trigger);
      trigger.dataset[MOUNTED_FLAG] = 'true';
      trigger.classList.add('ev-size-guide__trigger--mounted');
      trigger.removeAttribute('hidden');
      trigger.removeAttribute('aria-hidden');
    });

    return true;
  }

  function whenSwatchSlotReady(callback) {
    if (mountTriggersIntoSwatchSlots()) {
      callback(true);
      return;
    }

    var done = false;
    var observer = new MutationObserver(function () {
      if (done) return;
      if (mountTriggersIntoSwatchSlots()) {
        done = true;
        observer.disconnect();
        callback(true);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(function () {
      if (done) return;
      done = true;
      observer.disconnect();
      mountTriggersIntoSwatchSlots();
      callback(!!document.querySelector('.swatch-size-chart [data-ev-size-guide-open], .ev-size-guide__trigger--mounted'));
    }, SWATCH_WAIT_MS);
  }

  function ensureModalOnBody(modal) {
    if (!modal || !document.body) return;
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
  }

  function initSizeGuide() {
    if (!document.body || document.body.dataset[INIT_FLAG] === 'true') return;
    document.body.dataset[INIT_FLAG] = 'true';

    var modal = document.getElementById('evSizeGuide');
    if (!modal) return;
    ensureModalOnBody(modal);

    var backdrop = modal.querySelector('[data-ev-size-guide-backdrop]');
    var panel = modal.querySelector('[data-ev-size-guide-panel]') || modal.querySelector('.ev-size-guide__panel');
    var closeBtn = modal.querySelector('[data-ev-size-guide-close]');
    var lastOpener = null;

    initTabs(panel);
    initUnitToggle(panel);

    function setOpen(isOpen) {
      ensureModalOnBody(modal);
      modal.classList.toggle(OPEN_CLASS, isOpen);
      modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      document.body.classList.toggle(BODY_LOCK_CLASS, isOpen);
    }

    function closeModal() {
      if (!modal.classList.contains(OPEN_CLASS)) return;
      setOpen(false);
      if (lastOpener && typeof lastOpener.focus === 'function') {
        lastOpener.focus();
      }
      lastOpener = null;
    }

    function openModal(trigger) {
      var mode = trigger.getAttribute('data-chart-mode') || 'fallback';
      showPanelContent(modal, mode);
      if (mode === 'image') {
        ensureChartImage(modal, trigger);
      }
      if (mode === 'table') {
        activateTab(panel, 'chart');
        var tableRoot = panel.querySelector('[data-ev-size-guide-table]');
        if (tableRoot) {
          applyUnit(panel, (tableRoot.getAttribute('data-ev-sg-source-unit') || 'cm').toLowerCase());
        }
      }
      lastOpener = trigger;
      setOpen(true);
      window.setTimeout(function () {
        var focusables = getFocusableElements(panel);
        var target = closeBtn || (focusables.length ? focusables[0] : null);
        if (target) target.focus();
      }, 0);
    }

    // Event delegation so remount into .swatch-size-chart keeps clicks working.
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-ev-size-guide-open]');
      if (!trigger) return;
      event.preventDefault();
      openModal(trigger);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    if (backdrop) {
      backdrop.addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains(OPEN_CLASS)) {
        event.preventDefault();
        closeModal();
        return;
      }
      if (modal.classList.contains(OPEN_CLASS)) {
        trapTabKey(event, panel);
      }
    });

    var waLinks = modal.querySelectorAll('[data-ev-size-guide-whatsapp]');
    Array.prototype.forEach.call(waLinks, function (waLink) {
      waLink.addEventListener('click', function () {
        var trigger = lastOpener || document.querySelector('[data-ev-size-guide-open]');
        if (!trigger) return;
        var href = buildWhatsAppHref(
          trigger.getAttribute('data-whatsapp-base'),
          trigger.getAttribute('data-product-title'),
          trigger.getAttribute('data-product-url')
        );
        waLink.setAttribute('href', href);
      });
    });

    whenSwatchSlotReady(function () {
      ensureModalOnBody(modal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuide);
  } else {
    initSizeGuide();
  }
})();
